import React, { Fragment } from 'react';
import Card from '@material-ui/core/Card';

import { CardText } from 'material-ui/Card';
import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';
import { Column } from 'react-virtualized';
import { formatHoursDays } from 'helpers/Formatter';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
  },
};

export const AvgInsightsTable = ({ graphData, onClick, level, showTable, timePeriod }) => {
  if (!showTable) return null;
  if (!graphData[level].children) return null;
  if (graphData[level].childen && graphData[level].childen.length === 0) return null;

  const getTableData = () => {
    return graphData[level].children.map(child => {
      return {
        name: child.insight_type_name,
        avg_time_fix: formatHoursDays(child['avg_time_fix_minutes'], timePeriod),
        tickets_satisfaction_rate:
          parseInt(child['tickets_satisfaction_rate'], 10) === 0
            ? ''
            : child['tickets_satisfaction_rate'],
        tickets_opened_count: child['tickets_opened_count'],
        tickets_closed_count: child['tickets_closed_count'],
        insight_id: child['insight_id'],
      };
    });
  };

  return (
    <div className="col-sm-12">
      <div className="row" style={{ padding: '0' }}>
        <Card style={style.transactionCard}>
          <CardText expandable={true} style={{ padding: '0', height: '300px' }}>
            <Fragment>
              <ReactVirtualizedTable
                data={getTableData()}
                rowRenderer={defaultRowRenderer}
                onRowClick={({ rowData }) => onClick(rowData.insight_id, 'category')}
              >
                <Column width={200} label={graphData[level].child_type} dataKey="name" />
                <Column width={150} label="Tickets Opened" dataKey="tickets_opened_count" />
                <Column width={150} label="Tickets Closed" dataKey="tickets_closed_count" />
                <Column width={175} label={`Avg time fix (${timePeriod})`} dataKey="avg_time_fix" />
                <Column
                  width={200}
                  label="Avg Satisfaction Rating"
                  dataKey="tickets_satisfaction_rate"
                />
              </ReactVirtualizedTable>
            </Fragment>
          </CardText>
        </Card>
      </div>
    </div>
  );
};
